<form class="flex flex-col flex-grow" [formGroup]="formGroup()" (ngSubmit)="onSubmitPress()">
  <ng-content/>
  <div [ngClass]="{'mt-auto': !noButtonPadding()}">
    @if (buttonDescription()) {
      <p class="italic text-sm text-muted-color mb-4">{{ buttonDescription() }}</p>
    }
    <div class="flex justify-between gap-2">
      <ng-content select="[additionalButtons]"/>
      <p-button class="flex-1" styleClass="w-full" type="submit"
                [loading]="state() === 'loading'"
                [disabled]="this.formGroup().invalid"
                severity="primary"
                [size]="buttonSize()"
                [label]="submitButtonLabel()"
      />
    </div>
    <ng-content select="[belowButton]"/>
  </div>
</form>
